export class InvalidSectionTypeError extends Error {
    constructor(type: string) {
        super(`${type} is not a valid section type`);
    }
}
